<template>
  <div class="timeline">
    <div v-for="item in data" class="item">
      <div class="mark"></div>
      <div class="date" v-if="item.date !== null">
        {{ item.date | localedShortDate }}
        <br>
        {{ item.date | timeFormat }}
      </div>
      <div class="item-content">
        <div class="status" v-if="item.name !== null">
          {{ item.title }}
          <b-tooltip :label="$t('docflow.signed')"
                     class="sign-ico"
                     type="is-light"
                     v-if="item.isSigned">
            <b-icon icon="check-decagram" size="is-small"></b-icon>
          </b-tooltip>
        </div>
        <div class="note" v-if="item.note !== null" v-html="nl2br(item.note)"></div>
        <div class="files" v-if="item.attachments.length > 0">
          <div class="file-item is-clearfix" v-for="file in item.attachments">
            <div class="ico">
              <div :class="`file-type-ico ${file.extension}`"></div>
            </div>
            <div class="name">
              <a :href="file.file" target="_blank">
                <span>{{ file.name }}</span>
                <b-icon icon="download" size="is-small" class="download"></b-icon>
              </a>
              <a @click="removeFile(file.id)" class="fileDelete" v-if="file.removable">
                <b-icon icon="delete" size="is-small" class="download"></b-icon>
              </a>
            </div>
            <div class="date">{{ file.created_at | localedDateWithYear }}</div>
          </div>
        </div>
        <b-upload v-model="file" @input="fileUpload" v-if="item.canUpload"
                  :disabled="disabled">
          <a class="button is-primary is-small mt-10">
            <b-icon icon="file-outline" size="is-small"></b-icon>
            <span>{{ $t('interface.uploadFile') }}</span>
          </a>
        </b-upload>
        <button class="button is-success is-small"
                :disabled="disabled"
                @click="$emit('next-state')"
                v-if="item.nextState">
          {{ item.nextState }}
        </button>
        <button class="button is-danger is-small reject"
                :disabled="disabled"
                @click="$emit('reject')"
                v-if="item.canReject">
          {{ $t('interface.reject') }}
        </button>
      </div>
    </div>
    <div class="has-text-grey-light mb-25 mt-15" v-if="data.length === 0">
      {{ $t('interface.noTimelineActions') }}
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data', 'disabled'],
    data() {
      return {
        file: null
      }
    },
    methods: {
      fileUpload() {
        this.$emit('file-upload', this.file)
        this.file = null
      },
      removeFile(fileId) {
        this.$emit('remove-file', fileId)
      },
      nl2br(str) {
        if (typeof str === 'undefined' || str === null)
          return ''
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .timeline {
    .reject {
      margin-left: 5px;
    }

    .item {
      position: relative;

      &:not(:last-child):after {
        content: '';
        display: block;
        width: 2px;
        position: absolute;
        top: 15px;
        bottom: -15px;
        background: #444;
        left: 62px;
      }

      .mark {
        position: absolute;
        top: 4px;
        width: 14px;
        height: 14px;
        background: #444;
        border-radius: 50%;
        left: 56px;

        &:after {
          content: '';
          display: block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          position: relative;
          top: 4px;
          left: 4px;
          background: #f6f6f6;
        }
      }

      & > .date {
        font-size: 13px;
        height: 14px;
        line-height: 15px;
        position: absolute;
        top: 0px;
        left: 0;
        color: #888;
      }

      .item-content {
        padding-left: 80px;
        padding-bottom: 10px;

        .separator {
          margin-top: 10px;
        }

        .status {
          font-size: 15px;
        }

        .note {
          font-size: 13px;
          color: #888;
        }

        .files {
          margin-top: 5px;

          .file-item {
            line-height: 19px;
            margin-top: 10px;

            .ico {
              width: 36px;
              text-align: left;
              position: relative;
              left: -4px;
              display: inline-block;
              float: left;
            }

            .name {
              font-size: 14px;

              .fileDelete {
                position: relative;
                top: -1px;
                left: -2px;
              }

              span {
                display: inline-block;
              }

              .download {
                position: relative;
                top: 2px;
                margin-left: 4px;
              }
            }

            .date {
              font-size: 13px;
              color: #888;
            }
          }
        }
      }
    }
  }
</style>
